<template>
     <v-container fluid>
         <v-card>
            <v-toolbar>
                <v-icon>edit</v-icon>
                <v-toolbar-title class="font-weight-light">&nbsp;Proceso Mensual Páginas Amarillas</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                    <v-icon v-if="action.esFrecuente">favorite</v-icon>
                    <v-icon v-else>favorite_border</v-icon>
                    </v-btn>
                </template>
                <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
                <span v-else>Agregar a Tareas Frecuentes</span>  
                </v-tooltip>
            </v-toolbar>
            <v-card-text>
                <v-row>
                    <v-container>
                         <v-card>
                             <v-card-title>
                                Actualizar Base Mensual
                            </v-card-title>
                            <v-card-text>
                                <v-col cols ="3">
                                    <v-text-field v-model="filtro.periodo" label="Fecha " type="date" prepend-icon="event"></v-text-field>
                                </v-col>                            
                                <span class="subtitle">
                                    Atención:
                                    <br>
                                    <ul>
                                        <li>En BasesExternas  debe existir la tabla 'BASE ANSES {{ periodoFormateado}}'</li>
                                        <li>La tabla debe contener los campos: Cuil, Nombres, CBU, Total_Haber, Desct_Obligatorios, Desct_3eros, Beneficios, Cupo_02, Cupo_03</li>
                                    </ul>
                                </span>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn dark  color="orange"  @click="actualizar()">
                                    Actualizar Base&nbsp;
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-container>
                </v-row>

                <v-row>
                    <v-container>
                         <v-card>
                             <v-card-title>
                               Actualizar CBU producto PV
                            </v-card-title>
                            <v-card-text>
                                <span class="subtitle">
                                    Este proceso busca los CBUs de personas que no tenga uno asociado, para los productos de Tipo PV, y luego inserta los que se encuentren.
                                    <br>                                    
                                </span>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn dark  color="orange" @click="procesarReporteActualizacionCBUs()">
                                    Generar Reporte&nbsp;
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn dark v-if="puedeProcesarActualizacionCBUs" color="green" @click="procesarActualizacionCBUs()">
                                    Procesar&nbsp;
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-container>
                </v-row>


                <v-row>
                    <v-container>
                         <v-card>
                             <v-card-title>
                                Asociar CBU producto PV
                            </v-card-title>
                            <v-card-text>
                                <span class="subtitle">
                                    Este proceso busca los créditos de los productos de Tipo PV que no tengan un CBU asociado y, en caso que el Cliente tenga un CBU activo, lo asocia.
                                    <br>                                    
                                </span>
                            </v-card-text>
                            <v-card-actions>                                                           
                                <v-btn dark  color="orange" @click="procesarReporteAsociarCbuProductoPV()">
                                    Generar Reporte&nbsp;
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn dark  color="green" v-if="puedeProcesarAsociarCbuProductoPV" @click="procesarAsociarCbuProductoPV">
                                    Procesar&nbsp;
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-container>
                </v-row>

                <v-row>
                    <v-container>
                         <v-card>
                             <v-card-title>
                                Update monto Ingresos
                            </v-card-title>
                            <v-card-text>
                                <span class="subtitle">
                                     Este proceso busca los importes liquidos y acualiza el dato en el legajo
                                </span>
                            </v-card-text>
                            <v-card-actions>
                                <!-- <v-btn dark  color="orange" @click="seleccionarIngresos()">
                                    Seleccionar Ingresos&nbsp;
                                </v-btn> -->
                                <v-spacer></v-spacer>
                                <v-btn dark  color="green"  @click="procesarIngresos">
                                    Procesar&nbsp;
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-container>
                </v-row>
             </v-card-text>
         </v-card>

        <app-loading :loading="loading"></app-loading>

     </v-container>
</template>
<script>

import { http } from '@/axios'
import { format } from 'date-fns'

import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
    data() {
        return {
            filtro: {periodo: null},
            loading: false,
            puedeProcesarActualizacionCBUs: false,
            puedeProcesarAsociarCbuProductoPV:false,
            puedeProcesarIngresos:false
        }
    },
    async created() { 
        this.filtro.periodo = this.$moment(new Date()).format('YYYY-MM-DD'); 
    }, 
    computed: {
        ...mapGetters(['activeTask','getActionFromLink','user','closeRelatedTasks']),
        action: function(){
            return this.getActionFromLink(this.$route.path) 
        },
        periodoFormateado: function(){
            return format(this.filtro.periodo, 'MM-YYYY')
        },
    },
  methods: {
    ...mapMutations(["setActiveTask","alertClear", "alertSuccess", "alertWarning", "alertError","setReporteActivo"]),
    ...mapActions(['setStatusTareaFrecuente']),    
    
    async actualizar(){

        var self = this;

        self.loading = true;

        try{

            await http.post('filegeneration/actualizarbasemensual', JSON.stringify( {parametros: this.filtro} ) )
            .then(resp => {
                if(resp.error){
                    self.alertError(resp.error);
                }
                else{
                    self.alertSuccess('Se actualizo la base correctamente');
                }

                })
                .catch((e) => {
                    self.alertError(e)
                });

        }catch(error){
            self.alertError(error)
        }

        self.loading = false;
    },
    async procesarReporteActualizacionCBUs(){

        var self = this;

        try {
            self.loading = true;
        
            this.setReporteActivo({reporte: 'ReporteActualizacionCBUs.trdp'})
            window.open('/report-viewer');
            
            this.puedeProcesarActualizacionCBUs = true;

        } catch (error) {
            // Error
            self.alertError(error)
        }
        self.loading = false

    },
    async procesarActualizacionCBUs(){

        var self = this;

        self.loading = true;

        try{

            await http.post('filegeneration/reporteactualizacioncbu', JSON.stringify( {} ) )
            .then(resp => {
                if(resp.error){
                    self.alertError(resp.error);
                }
                else{
                    self.alertSuccess('Actualizacion de CBU realizada correctamente');
                }

                })
                .catch((e) => {
                    self.alertError(e)
                });

        }catch(error){
            self.alertError(error)
        }

        self.loading = false;
    },
    async procesarReporteAsociarCbuProductoPV(){

        var self = this;

        try {
            self.loading = true;
        

            this.setReporteActivo({reporte: 'AsociarCBUPorProductoPV.trdp'})
            window.open('/report-viewer');
            
            this.puedeProcesarAsociarCbuProductoPV = true;

        } catch (error) {
            // Error
            self.alertError(error)
        }
        self.loading = false

    },
    async procesarAsociarCbuProductoPV(){

        var self = this;

        self.loading = true;

        try{

            await http.post('filegeneration/reporteactualizacioncbuparaproductopv', JSON.stringify( {} ) )
            .then(resp => {
                if(resp.error){
                    self.alertError(resp.error);
                }
                else{
                    self.alertSuccess('Asociacion de CBU realizada correctamente');
                }

                })
                .catch((e) => {
                    self.alertError(e)
                });

        }catch(error){
            self.alertError(error)
        }

        self.loading = false;
    },
    async seleccionarIngresos(){

        var self = this;

        self.loading = true;

        try{

            await http.post('filegeneration/seleccionaringresosacambiar', JSON.stringify( {parametros: this.filtro} ) )
            .then(resp => {
                if(resp.error){
                    self.alertError(resp.error);
                }
                else{
                    self.alertSuccess('Se Seleccionaron los ingresos');
                }
             this.puedeProcesarIngresos = true;
                })
                .catch((e) => {
                    self.alertError(e)
                });

        }catch(error){
            self.alertError(error)
        }

        self.loading = false;
    },
    async procesarIngresos(){

        var self = this;

        self.loading = true;

        try{

            await http.post('filegeneration/updateingresosacambiar', JSON.stringify( {parametros: this.filtro} ) )
            .then(resp => {
                if(resp.error){
                    self.alertError(resp.error);
                }
                else{
                    self.alertSuccess('Se actualizaron los montos con exito');
                }

                })
                .catch((e) => {
                    self.alertError(e)
                });

        }catch(error){
            self.alertError(error)
        }

        self.loading = false;
    },
},
  
}
</script>